import type { Agency } from "@asap/shared/schemas/agency";
import { useApi } from "~/composables/useApi";

const AGENCIES_PAGE_SIZE = 200;

export const useAgencyApi = () => {
  const { invoke } = useApi();

  // Pappers sync stores every establishment, so large groups span several pages
  const listCompanyAgencies = async (companyId: string) => {
    const agencies: Agency[] = [];
    for (let pageIndex = 0; ; pageIndex++) {
      const answer = await invoke({
        path: "agencies",
        method: "GET",
        query: { companyId, pageIndex, pageSize: AGENCIES_PAGE_SIZE, orderColumn: "name" },
      });
      if (!answer.success) throw new Error(answer.error.clientMessage ?? answer.error.message);
      agencies.push(...answer.data.items);
      if (!answer.data.items.length || agencies.length >= answer.data.totalItems) return agencies;
    }
  };

  return { listCompanyAgencies };
};
